export default __webpack_public_path__ + "static/media/info.38f29d03.png";